import { makeAutoObservable } from 'mobx';
import { IFedexV2RegistrationAddress } from '../../../../../../../models/IntegrationsTypes';
import { IFedexV2AddressChanges } from './fedex-v2-credentials.types';

class FedexV2AddressStore {
    private _changes: IFedexV2AddressChanges = {};

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    get accountNumber() {
        return this._changes.accountNumber ?? '';
    }

    get customerName() {
        return this._changes.customerName ?? '';
    }

    get street1() {
        return this._changes.street1 ?? '';
    }

    get street2() {
        return this._changes.street2 ?? '';
    }

    get city() {
        return this._changes.city ?? '';
    }

    get state() {
        return this._changes.state ?? '';
    }

    get postalCode() {
        return this._changes.postalCode ?? '';
    }

    get countryCode() {
        return this._changes.countryCode ?? 'US';
    }

    get residential() {
        return this._changes.residential ?? false;
    }

    setAccountNumber(value: string) {
        this._changes.accountNumber = value;
    }

    setCustomerName(value: string) {
        this._changes.customerName = value;
    }

    setStreet1(value: string) {
        this._changes.street1 = value;
    }

    setStreet2(value: string) {
        this._changes.street2 = value;
    }

    setCity(value: string) {
        this._changes.city = value;
    }

    setState(value: string) {
        this._changes.state = value;
    }

    setPostalCode(value: string) {
        this._changes.postalCode = value;
    }

    setCountryCode(value: string) {
        this._changes.countryCode = value;
    }

    setResidential(value: boolean) {
        this._changes.residential = value;
    }

    buildAddress(): IFedexV2RegistrationAddress {
        const streetLines = [this.street1, this.street2].filter(Boolean);
        return {
            streetLines,
            city: this.city,
            stateOrProvinceCode: this.state,
            postalCode: this.postalCode,
            countryCode: this.countryCode,
            residential: this.residential,
        };
    }
}

export default FedexV2AddressStore;
